import * as React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import CreateFolderIcon from '@mui/icons-material/CreateNewFolderOutlined';
import * as FolderStore from '../store/Folder';
import * as DialogFactory from '../services/Dialog.Factory';
import { DialogProviderContext } from './DialogProvider';
import { useAppDispatch } from '../store';

const CreateFolderButton = (props: { iconLabelButton?: boolean }) => {
    const dispatch = useAppDispatch();

    return (
        <DialogProviderContext.Consumer>
            {(dialogContext) => {

                const handleCreate = () => {
                    const dialog = DialogFactory.buildFolderNameDialog(dialogContext, (folderName: string) => {
                        return new Promise((resolve, reject) => {
                            dispatch(FolderStore.actionCreators.createFolder(folderName, undefined, (success: boolean, errors?: string[]) => {
                                if (success) {
                                    resolve([]);
                                    dialog.close();
                                } else {
                                    resolve(errors);
                                }
                            }));
                        });
                    });
                    dialog.open();
                };

                if (props.iconLabelButton === true) {
                    return (
                        <Button variant="outlined" startIcon={<CreateFolderIcon />} onClick={handleCreate}>
                            Create new folder
                        </Button>
                    )
                }

                return (
                    <Tooltip title="Create new folder">
                        <IconButton aria-label="create folder" onClick={handleCreate}>
                            <CreateFolderIcon />
                        </IconButton>
                    </Tooltip>
                );

            }}
        </DialogProviderContext.Consumer>
    );
};

export default CreateFolderButton;